// extracted by mini-css-extract-plugin
export default {"loader":"w28eT","wheel-rotate-semi":"fw8hK","wheelRotateSemi":"fw8hK","wheel-rotate-inner":"JQG4I","wheelRotateInner":"JQG4I","small":"_2lKvU","medium":"zdkE8","large":"b-WIs"};